// src/utils/nprogress.js
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import 'nprogress/nprogress2.css';

NProgress.configure({ showSpinner: true });


export default NProgress;